/**
 * 基础信息、配置等API
 */
import request from '../setup/request';
const base = {
  /**
   * 初始化
   * @returns {AxiosPromise}
   */
  getBaseInit(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.base.init',
    });
  },
  /**
   * 获取系统通知
   * @returns {AxiosPromise}
   */
  getSysNotice(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.base.sysNotice',
    });
  },
  /**
   * 获取短信验证码
   * @returns {AxiosPromise}
   */
  getSysMessage(params) {
    return request.post('', {
      ...params,
      method: 'ih.user.auth.getSmsAuthCode',
    });
  },
  /**
   * 校验短信验证码并登录
   * @returns {AxiosPromise}
   */
  getCheckSmsAuthCode(params) {
    return request.post('', {
      ...params,
      method: 'ih.user.auth.phoneAuth',
    });
  },
  /**
   *获取用于绑定手机的验证码接口
   * @returns {AxiosPromise}
   */
  getBindPhoneCaptcha(params) {
    return request.post('', {
      ...params,
      method: 'ih.user.bind.getBindPhoneCaptcha',
    });
  },
  /**
   *绑定手机号
   * @returns {AxiosPromise}
   */
  getBindPhone(params) {
    return request.post('', {
      ...params,
      method: 'ih.user.bind.bindPhone',
    });
  },
  /**
   *通过接收手机号码和短息内容参数发送短信，并返回报告查询的唯一标识码
   *
   */
  getSendSmsEx(params) {
    return request.post('', {
      ...params,
      method: 'ih.base.sms.sendSmsEx',
    });
  },
  /**
   *
   * 网站订单中输入手机号码发送短信
   * http://124.127.40.91:8888/dc/extra/query/sendMsg
   */
  getQuerySendmsg(params) {
    return request.post('', {
      ...params,
      method: 'ih.smcdc.query.sendmsg',
    });
  },
  /**
   *
   * 用户打开短信地址，地址后面为随机数，上送随机数调用接口获取相应票的数据
   * http://124.127.40.91:8888/dc/extra/query/byCode
   */
  getQueryByCode(params) {
    return request.post('', {
      ...params,
      method: 'ih.smcdc.query.byCode',
    });
  },
};

export default base;
